





























import Vue from "vue";
import FormItem from "@/components/Money/FormItem.vue";
import typeList from "@/constants/typeList";
import { Component, Prop } from "vue-property-decorator";
@Component({
  components: { FormItem }
})
export default class NumberPad extends Vue {
  @Prop(Number) value!: number;
  output: string = this.value.toString();
  notes: string = "";
  inputContent(event: MouseEvent) {
    const button = event.target as HTMLButtonElement;
    const input = button.textContent!;
    if (this.output.length === 16) {
      return;
    }
    if (this.output === "0" && "0123456789".indexOf(input) >= 0) {
      this.output = input;
      return;
    }
    if (this.output.indexOf(".") >= 0 && input === ".") {
      return;
    }
    this.output += input;
  }
  remove() {
    if (this.output.length === 1) {
      this.output = "0";
    } else {
      this.output = this.output.slice(0, -1);
    }
  }
  clear() {
    this.output = "0";
    this.notes = "";
  }
  ok() {
    this.$emit("update:value", parseFloat(this.output));
    this.$emit("update:notes", this.notes);
    this.$emit("submit", parseFloat(this.output));
    this.clear();
  }
}
